// extracted by mini-css-extract-plugin
export var ldsEllipsis = "Spinner-module--ldsEllipsis--Pdfvy";
export var ldsEllipsis1 = "Spinner-module--ldsEllipsis1--8yug3";
export var ldsEllipsis2 = "Spinner-module--ldsEllipsis2--CRwla";
export var ldsEllipsis3 = "Spinner-module--ldsEllipsis3--OKtbL";